import { Modal } from "bootstrap"
import { getMessaging, getToken, isSupported } from "firebase/messaging"
import initializeFirebaseApp, { vapidKey } from "../shared/firebase-app"
import ReactNativeTokenController from "./react_native_token_base_controller"

export default class extends ReactNativeTokenController {
  static values = { projectId: String }

  connect() {
    isSupported().then(isBrowserSupported => {
      if (isBrowserSupported) {
        switch (Notification.permission) {
          case "default":
            this.modal = new Modal(this.element)
            this.modal.show()
            break
          case "granted":
            this.#upsertToken()
        }
      } else if (window.ReactNativeWebView) {
        this.requestReactNativeToken()
      }
    })
  }

  request() {
    this.modal?.hide()
    Notification.requestPermission().then(permission => {
      if (permission === "granted") {
        this.#upsertToken()
      }
    })
  }

  #upsertToken() {
    const firebaseApp = initializeFirebaseApp(this.projectIdValue)

    navigator.serviceWorker
      .register(`/firebase-messaging-sw-${this.projectIdValue}.js`, { scope: "/firebase-cloud-messaging-push-scope" })
      .then(serviceWorkerRegistration =>
        getToken(getMessaging(firebaseApp), {
          serviceWorkerRegistration,
          vapidKey: vapidKey(this.projectIdValue)
        }).then(token => {
          this.setTokenAndSubmitForm(token)
        })
      )
  }
}
